/** Input within this window makes a present minute "active". */
export const ACTIVE_INPUT_WINDOW_MS = 5 * 60_000;
/** Presence stops counting this long after the last input: Firefox reports
 *  a window covered by another window as visible, so visibility alone
 *  cannot end a stretch. */
export const PRESENT_INPUT_CAP_MS = 30 * 60_000;
/** The client re-sends its open segment this often while it grows. */
export const PRESENCE_CHECKPOINT_MS = 60_000;
/** A segment is closed and reopened at this age so its offset arrays stay
 *  bounded (1440 minutes). */
export const PRESENCE_SEGMENT_MAX_MS = 24 * 3_600_000;
/** A day counts toward "days active" once it has this much active time
 *  (spec §3.8). Any active time at all would count a day on which a single
 *  stray pointer event was the only thing that happened. */
export const ACTIVE_DAY_MIN_MS = 60_000;
/** Historical tab: actions closer than this belong to one inferred session. */
export const INFERRED_SESSION_GAP_MS = 30 * 60_000;
